import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

var firebaseConfig = {
        apiKey: "AIzaSyBohcShAReNOvvSzwnOUgmVWCZW5XajslU",
        authDomain: "addclarity-b2570.firebaseapp.com",
        databaseURL: "https://addclarity-b2570.firebaseio.com",
        projectId: "addclarity-b2570",
        storageBucket: "addclarity-b2570.appspot.com",
        messagingSenderId: "582829923432",
        appId: "1:582829923432:web:e5173a155ec48870"
  };
  
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  // firebase utils
const db = firebase.firestore();
const auth = firebase.auth()
const currentUser = auth.currentUser;
const storage = firebase.storage();

const usersCollection = db.collection('users')
const organisationsCollection = db.collection('organisations')

export {
  db,
  storage,
  auth,
  organisationsCollection,
  usersCollection,
  currentUser
};